import { render, staticRenderFns } from "./VideoListModal.vue?vue&type=template&id=0795a9b2&scoped=true"
import script from "./VideoListModal.vue?vue&type=script&lang=ts"
export * from "./VideoListModal.vue?vue&type=script&lang=ts"
import style0 from "./VideoListModal.vue?vue&type=style&index=0&id=0795a9b2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0795a9b2",
  null
  
)

export default component.exports